import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { REWARD_TYPE } from './JourneyBannerNextReward';
import JourneyBannerCoins from './JourneyBannerCoins';

export default function JourneyBannerAllRewards(props) {
  const { type, title, items, coins, centered } = props;

  const itemsToDisplay =
    type === REWARD_TYPE.TROPHY ? items.slice(0, 4) : items.slice(0, 2);

  const stepStyle = centered ? { alignItems: 'center' } : undefined;

  return (
    <div className="journey-next-step" style={stepStyle}>
      {title && <h6>{title}</h6>}
      {type === REWARD_TYPE.COINS ? (
        <JourneyBannerCoins coins={coins} />
      ) : (
        <div className="journey-next-step-info">
          {itemsToDisplay.map(i => (
            <img
              key={i}
              src={i}
              alt="step preview"
              className={cx('reward-image', {
                'coupon-voucher-image': type !== REWARD_TYPE.TROPHY,
              })}
            />
          ))}
        </div>
      )}
    </div>
  );
}

JourneyBannerAllRewards.propTypes = {
  type: PropTypes.oneOf(Object.values(REWARD_TYPE)).isRequired,
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
  coins: PropTypes.shape({
    wallet: PropTypes.number,
    charity: PropTypes.number,
  }),
  centered: PropTypes.bool,
};

JourneyBannerAllRewards.defaultProps = {
  title: null,
  items: [],
  coins: { wallet: 0, charity: 0 },
  centered: false,
};
